import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { resetPageMetaToDefault } from '../../utils/pageMeta';
import './NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'KRIME | Page Not Found';
    return () => {
      resetPageMetaToDefault();
    };
  }, []);

  return (
    <div className="not-found">
      <img
        src="/logo_navy_gold_silver.png"
        alt="KRIME"
        className="not-found-logo"
        onClick={() => navigate('/', { replace: true })}
        draggable="false"
      />
      <p className="not-found-heading">Page Not Found (404)</p>
      <p className="not-found-detail">
        The location or page you're looking for does not exist or may have been moved.
      </p>
    </div>
  );
};

export default NotFound;
